<template>
  <div class="animated fadeIn">
    <b-row class="my-0">
      <div class="col-sm-12">
        <b-card no-body class="mb-3 dashboard-card shadow-sm border-0 overflow-hidden">
          <div class="dashboard-header p-3 d-flex align-items-center justify-content-between text-white">
            <div class="d-flex align-items-center">
              <div class="header-icon-wrapper mr-3">
                <i class="fa fa-university"></i>
              </div>
              <div>
                <h5 class="mb-0 font-weight-bold">CAIXA INTERNO \ BANCÁRIO</h5>
                <small class="opacity-75">Gestão de movimentações financeiras</small>
              </div>
            </div>
            <div class="d-flex align-items-center filter-bar bg-white-10 rounded-pill p-1">
              <div class="px-3 d-none d-md-block">
                <small class="text-uppercase font-weight-bold letter-spacing-1">Conta:</small>
              </div>
              <cec-select-search
                v-model="contas.id" 
                @change="onChangeConta"
                :options="contas.options" 
                :state="!!contas.id"
                placeholder="-- Escolha uma Conta --"
                input-class="border-0 bg-transparent custom-select-transparent font-weight-bold"
                input-style="color: white !important;"
                style="min-width: 300px;"
              />
              <div class="px-3 d-none d-md-block border-left border-white-20">
                <small class="text-uppercase font-weight-bold letter-spacing-1">Data:</small>
              </div>
              <div class="d-flex align-items-center">
                <b-button variant="link" class="text-white px-2 py-0" @click.stop.prevent="decrementarData()">
                  <i class="fa fa-chevron-left"></i>
                </b-button>
                <cec-input-data
                  v-model="dtMovimento"
                  style="width: 130px;"
                />
                <b-button variant="link" class="text-white px-2 py-0" @click.stop.prevent="acrescentarData()">
                  <i class="fa fa-chevron-right"></i>
                </b-button>
              </div>
              <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm" @click="voltarParaPesquisa()">
                <i class="fa fa-arrow-left mr-1"></i> Voltar
              </b-button>
            </div>
          </div>

          <div class="dashboard-body bg-white p-3">
            <b-row>
              <b-col md="4" lg="2">
                <div class="stat-item border rounded p-3 text-center h-100 bg-light shadow-xs transition-hover">
                  <div class="stat-icon text-muted mb-2"><i class="fa fa-file-text-o"></i></div>
                  <div class="stat-label text-uppercase small font-weight-bold text-muted mb-1">Documentos</div>
                  <div class="stat-value h4 mb-0 font-weight-bold text-dark">{{tabelaMovimento.items.length}}</div>
                </div>
              </b-col>
              <b-col md="4" lg="2">
                <div class="stat-item border rounded p-3 text-center h-100 bg-soft-success shadow-xs transition-hover">
                  <div class="stat-icon text-success mb-2"><i class="fa fa-arrow-up"></i></div>
                  <div class="stat-label text-uppercase small font-weight-bold text-success mb-1">Total Créditos</div>
                  <div class="stat-value h4 mb-0 font-weight-bold text-success">{{caixa.registro.T_CREDITO}}</div>
                </div>
              </b-col>
              <b-col md="4" lg="2">
                <div class="stat-item border rounded p-3 text-center h-100 bg-soft-danger shadow-xs transition-hover">
                  <div class="stat-icon text-danger mb-2"><i class="fa fa-arrow-down"></i></div>
                  <div class="stat-label text-uppercase small font-weight-bold text-danger mb-1">Total Débitos</div>
                  <div class="stat-value h4 mb-0 font-weight-bold text-danger">{{caixa.registro.T_DEBITO}}</div>
                </div>
              </b-col>
              <b-col md="4" lg="2">
                <div class="stat-item border rounded p-3 text-center h-100 bg-soft-info shadow-xs transition-hover">
                  <div class="stat-icon text-info mb-2"><i class="fa fa-exchange"></i></div>
                  <div class="stat-label text-uppercase small font-weight-bold text-info mb-1">Compensação</div>
                  <div class="stat-value h4 mb-0 font-weight-bold text-info">{{caixa.registro.T_COMPENSACAO}}</div>
                </div>
              </b-col>
              <b-col md="4" lg="2">
                <div class="stat-item border rounded p-3 text-center h-100 bg-soft-primary shadow-xs transition-hover">
                  <div class="stat-icon text-primary mb-2"><i class="fa fa-history"></i></div>
                  <div class="stat-label text-uppercase small font-weight-bold text-primary mb-1">Saldo Anterior</div>
                  <div class="stat-value h4 mb-0 font-weight-bold text-primary">{{caixa.registro.SALDO_ANT}}</div>
                </div>
              </b-col>
              <b-col md="4" lg="2">
                <div class="stat-item border-primary rounded p-3 text-center h-100 bg-primary text-white shadow-sm scale-110 transition-hover">
                  <div class="stat-icon text-white-50 mb-2"><i class="fa fa-money"></i></div>
                  <div class="stat-label text-uppercase small font-weight-bold mb-1">Saldo Atual</div>
                  <div class="stat-value h4 mb-0 font-weight-bold">{{caixa.registro.SALDO_ATUAL}}</div>
                </div>
              </b-col>
            </b-row>
            <div class="mt-3 pt-3 border-top d-flex justify-content-start">
              <b-button pill variant="outline-info" class="mr-2 font-weight-bold" @click.stop.prevent="imprimirLivroCaixa()">
                <i class="fa fa-print mr-1"></i> Livro Caixa
              </b-button>
              <b-button pill variant="outline-info" class="font-weight-bold" @click.stop.prevent="imprimirMovimentoCaixa()">
                <i class="fa fa-calendar-check-o mr-1"></i> Movimento do Caixa
              </b-button>
            </div>
          </div>
        </b-card>
        <b-card  header-text-variant="white"
            header-tag="header"
            header-bg-variant="dark"
            body-class="alert-dark">
          <div slot="header">
            <b-row class="my-0 align-items-center" size="sm" >
              <b-col sm="3">
                <i class='fa fa-list-ul mr-2 text-primary'></i> <strong>Histórico de Lançamentos</strong>
              </b-col>
              
              <b-col class="text-right" sm="9">
                  <b-button pill size="sm" variant="success" class="px-3 shadow-sm font-weight-bold" @click.stop.prevent="onClick_abrirModalIncluirItem()">
                    <i class="fa fa-plus mr-1"></i> Adicionar Item
                  </b-button>
              </b-col>
            </b-row>
          </div>
          <div>
            <div class="col-sm-12">
              <div>
                <b-table 
                    striped 
                    hover
                    stacked="md"
                    small
                    responsive 
                    select-mode="single"
                    selectable
                    class="cec-table modern-table"
                    :busy="tabelaMovimento.isBusy"
                    @row-dblclicked="onClick_abrirModalAlterarItem" 
                    
                    :tbody-tr-class="rowClassListagem"
                    :items="tabelaMovimento.items" 
                    :fields="tabelaMovimento.fields">
                    
                    <template #cell(TIPO_MOV)="data">
                      <span :class="['badge-finance', 
                        data.value.trim() === 'CREDITO' ? 'bg-soft-success text-success' : 
                        data.value.trim() === 'DEBITO' ? 'bg-soft-danger text-danger' : 
                        'bg-soft-info text-info']">
                        {{ data.value }}
                      </span>
                    </template>

                    <template #cell(actions)="item">
                      <div class="d-flex justify-content-center">
                        <b-button 
                          @click.stop.prevent="onClick_abrirModalExcluir(item.item)" 
                          variant="soft-danger" 
                          class="action-pill mr-2 text-danger" 
                          :title="getMensagemBloqueioItemCaixa(item.item) || 'Excluir'"
                        >
                          <i class="fa fa-times"></i>
                        </b-button>
                        <b-button 
                          @click.stop.prevent="abrirModalTransferir(item.item)" 
                          variant="soft-primary" 
                          class="action-pill text-primary" 
                          title="Transferir"
                        >
                          <i class="fa fa-arrows-h"></i>
                        </b-button>
                      </div>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Carregando...</strong>
                        </div>
                    </template>
                </b-table>
              </div>
            </div>
          </div>
        </b-card>
      </div>
    </b-row>
      
    <!--  -----------------------------------------------------------------------------------
                                        MODAL INCLUIR ALTERAR TITULO 
          ----------------------------------------------------------------------------------- -->
    <div>
      <div>     
        <b-modal ref="modal-item-caixa" 
            id="modal-item-caixa" 
            hide-header
            body-class="p-0 overflow-hidden"
            no-close-on-esc
            no-close-on-backdrop
            hide-footer
            size="lg"
            @shown="focus_modalcaixaItem()" 
            content-class="border-0 shadow-lg"
        >
          <b-overlay :show="caixaItem.parametros.overlay" 
                      no-wrap 
                      z-index="1100" 
                      spinner-variant="primary"
                      spinner-type="border">
            <template #overlay>
              <div class="text-center">
                <b-icon icon="stopwatch" font-scale="3" animation="cylon" variant="primary"></b-icon>
                <p class="font-weight-bold text-primary mt-2">Processando lançamento...</p>
              </div>
            </template>
          </b-overlay>

          <div class="modal-header-premium p-3 d-flex align-items-center">
            <div class="header-icon-wrapper mr-3 bg-white-10">
              <i class="fa fa-calculator"></i>
            </div>
            <div>
              <h5 class="mb-0 font-weight-bold text-white">Item no Caixa</h5>
              <small class="text-white opacity-75">Gestão de movimentação financeira direta</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-item-caixa')">
              <i class="fa fa-times fa-lg"></i>
            </b-button>
          </div>

          <div class="p-4 bg-white">
              <div class="modal-info-bar mb-4 shadow-xs border">
                <b-row align-v="center">
                  <b-col md="5">
                    <small class="modal-label-premium d-block">Conta Bancária / Interna</small>
                    <span class="font-weight-bold text-dark"><i class="fa fa-university mr-2 text-muted"></i>{{nomeContaSelecionada}}</span>
                  </b-col>
                  <b-col md="3" class="border-left border-right text-center">
                    <small class="modal-label-premium d-block">Tipo Movimento</small>
                    <b-badge :variant="caixaItem.registro.TIPO_MOV === 'DEBITO' ? 'soft-danger' : 'soft-success'" class="badge-finance">
                      {{caixaItem.registro.TIPO_MOV}}
                    </b-badge>
                  </b-col>
                  <b-col md="4" class="text-right">
                    <small class="modal-label-premium d-block">Data do Movimento</small>
                    <span class="font-weight-bold text-dark"><i class="fa fa-calendar mr-2 text-muted"></i>{{dataDoMovimento}}</span>
                  </b-col>
                </b-row>
              </div>

              <div class="modal-section-title">
                <i class="fa fa-file-text-o mr-2 text-primary"></i> Identificação e Valores
              </div>

              <b-row class="modal-field-group">
                <b-col md="6">
                  <label class="modal-label-premium" for="edItemDocumento">Nº Documento</label>
                  <b-form-input 
                    type="text" 
                    ref="edItemDocumento" 
                    id="edItemDocumento" 
                    v-model="caixaItem.registro.DOCUMENTO" 
                    :state="!!caixaItem.registro.DOCUMENTO"
                    placeholder="Ex: NF-001" 
                    class="rounded-pill shadow-xs"
                  />
                </b-col>
                <b-col md="6">
                  <label class="modal-label-premium text-right d-block" for="valorItem">Valor do Lançamento</label>
                  <vue-autonumeric  
                    id="valorItem" 
                    v-model="caixaItem.registro.VL_MOV" 
                    :options="'Brazilian'"  
                    :class="['form-control rounded-pill shadow-xs',
                            { 'is-invalid': !caixaItem.registro.VL_MOV || caixaItem.registro.VL_MOV === null || caixaItem.registro.VL_MOV === 0 }]" 
                    style="text-align: right"
                  />
                </b-col>
              </b-row>

              <b-row class="modal-field-group">
                <b-col md="12">
                  <label class="modal-label-premium">Histórico Financeiro</label>
                  <historico-caixa-dropdown
                    v-model="caixaItem.registro.COD_PLANO"
                    :state="!!caixaItem.registro.COD_PLANO"
                    placeholder="Selecione o plano de contas..."
                    class="shadow-xs"
                    :tipo="caixaItem.registro.TIPO_MOV || 'DEBITO'"
                  />
                </b-col>
              </b-row>

              <b-row class="modal-field-group">
                <b-col md="12">
                  <label class="modal-label-premium">Cliente ou Fornecedor</label>
                  <cliente-pesquisa 
                    @retornaId="caixaItem.registro.CLIENTE_ID = $event"
                    :idInicial="caixaItem.registro.CLIENTE_ID"
                    :classe-required="!!caixaItem.registro.CLIENTE_ID"
                    place="Opcional: Pesquise pelo nome..."
                    labelBotao=""
                    ref="clientepesquisa"
                    idModal="clientepesquisa"
                    :layoutLinear="true"
                    :tamanhoColunaLabel='"3"'
                    :tamanhoColunaAutocomplete='"9"'
                    class="shadow-xs"
                  />
                </b-col>
              </b-row>

              <b-row class="modal-field-group">
                <b-col md="12">
                  <label class="modal-label-premium">Centro de Custo</label>
                  <centro-custo-drop-down 
                    v-model="caixaItem.registro.COD_CENTRO1"
                    :state="!!caixaItem.registro.COD_CENTRO1"
                    placeholder="Selecione a unidade..."
                  />
                </b-col>
              </b-row>

              <b-row class="modal-field-group">
                <b-col md="6">
                  <label class="modal-label-premium" for="tipoPagamento">Forma Pagto.</label>
                  <b-form-select 
                    id="tipoPagamento" 
                    ref="combotipo"
                    v-model="caixaItem.registro.FORMA"
                    :state="!!caixaItem.registro.FORMA"
                    :options="caixaItem.tipoPagamento.items"
                    class="rounded-pill shadow-xs"
                  >
                    <template slot="first">
                      <option :value="null">-- Selecione --</option>
                    </template>
                  </b-form-select>
                </b-col>
                <b-col md="6">
                  <label class="modal-label-premium" for="edItemObs">Descrição Complementar</label>
                  <b-form-input 
                    type="text" 
                    id="edItemObs" 
                    v-model="caixaItem.registro.OBS" 
                    :state="!!caixaItem.registro.OBS"
                    placeholder="Notas internas..." 
                    class="rounded-pill shadow-xs"
                  />
                </b-col>
              </b-row>

              <b-row v-if="caixaItem.registro.CONTADOR > 0" class="modal-field-group mt-3 bg-soft-warning p-3 rounded border">
                <b-col md="12">
                  <label class="modal-label-premium text-warning font-weight-bold" for="edMotivoAlteracao">
                    <i class="fa fa-exclamation-triangle mr-2"></i> JUSTIFICATIVA DA ALTERAÇÃO
                  </label>
                  <b-form-input 
                    type="text" 
                    ref="edMotivoAlteracao" 
                    id="edMotivoAlteracao" 
                    v-model="caixaItem.info.motivoAlteracao" 
                    :state="!!caixaItem.info.motivoAlteracao"
                    placeholder="Por que este registro está sendo alterado?" 
                    class="border-warning shadow-xs"
                  />
                </b-col>
              </b-row>
          </div>

          <div class="modal-footer-premium p-3">
            <b-row>
              <b-col class="text-left">
                <b-button :disabled="caixaItem.parametros.overlay" variant="soft-danger" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modal-item-caixa')">
                  FECHAR
                </b-button>
              </b-col>
              <b-col class="text-right">
                <b-button v-if="!caixaItem.registro.CONTADOR" :disabled="caixaItem.parametros.overlay" variant="success" pill class="px-4 font-weight-bold shadow-sm" @click="postItem()">
                  <i class="fa fa-save mr-1"></i> GRAVAR
                </b-button>
                <b-button v-else :disabled="caixaItem.parametros.overlay" variant="warning" pill class="px-4 font-weight-bold shadow-sm" @click="editItem()">
                  <i class="fa fa-save mr-1"></i> SALVAR ALTERAÇÕES
                </b-button>
              </b-col>
            </b-row>
          </div>
        </b-modal>
      </div>
    </div>
    <!--  ------------------------------ FIM MODAL EXCLUIR TITULO ---------------------------- -->

    <!--  -----------------------------------------------------------------------------------
                                        MODAL EXCLUIR TITULO 
          ----------------------------------------------------------------------------------- -->
    <div>
      <div>     
        <b-modal ref="modal-excluir" 
            id="modal-excluir" 
            hide-header
            no-close-on-esc
            no-close-on-backdrop
            body-class="p-0 overflow-hidden"
            size="lg"
            @shown="focus_modalExcluir()" 
            content-class="border-0 shadow-lg"
        >
          <b-overlay :show="caixaItem.excluir.parametros.overlay" 
                      no-wrap 
                      z-index="1100" 
                      spinner-variant="danger"
                      spinner-type="border">
            <template #overlay>
              <div class="text-center text-danger">
                <i class="fa fa-trash-o fa-3x mb-2"></i>
                <p class="font-weight-bold">Excluindo lançamento...</p>
              </div>
            </template>
          </b-overlay>

          <div class="modal-header-premium p-3 d-flex align-items-center bg-danger" style="background: linear-gradient(135deg, #dc3545 0%, #a71d2a 100%) !important;">
            <div class="header-icon-wrapper mr-3 bg-white-10">
              <i class="fa fa-trash-o"></i>
            </div>
            <div>
              <h5 class="mb-0 font-weight-bold text-white">Excluir Item do Caixa</h5>
              <small class="text-white opacity-75">Esta ação não poderá ser desfeita</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-excluir')">
              <i class="fa fa-times fa-lg"></i>
            </b-button>
          </div>

          <div class="p-4 bg-white">
              <div class="modal-info-bar mb-4 bg-soft-danger border">
                <b-row>
                  <b-col md="6">
                    <small class="modal-label-premium">Histórico</small>
                    <p class="mb-2 font-weight-bold">{{caixaItem.info.nomeHistorico}}</p>
                    <small class="modal-label-premium">Centro de Custo</small>
                    <p class="mb-0">{{caixaItem.info.nomeCentroCusto}}</p>
                  </b-col>
                  <b-col md="6" class="border-left">
                    <small class="modal-label-premium">Descrição</small>
                    <p class="mb-2">{{caixaItem.info.descricao}}</p>
                    <small class="modal-label-premium">Valor</small>
                    <p class="mb-0 h5 text-danger font-weight-bold">{{caixaItem.info.valor}}</p>
                  </b-col>
                </b-row>
              </div>
              
              <div class="modal-field-group">
                <label class="modal-label-premium text-danger font-weight-bold" for="edItemObsExcluir">
                  <i class="fa fa-pencil mr-1"></i> Motivo da Exclusão
                </label>
                <b-form-input 
                  type="text" 
                  id="edItemObsExcluir" 
                  v-model="caixaItem.info.motivoExclusao" 
                  ref="edItemObsExcluir"
                  :state="validou_item_motivo_exclusao"
                  placeholder="Justifique a exclusão deste item para os registros de auditoria" 
                  class="rounded-pill border-danger shadow-xs"
                />
              </div>
          </div>

          <div class="modal-footer-premium p-3 bg-light">
            <b-row class="w-100 m-0">
              <b-col class="p-0">
                <b-button :disabled="caixaItem.excluir.parametros.overlay" variant="soft-primary" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modal-excluir')">
                  CANCELAR
                </b-button>
              </b-col>
              <b-col class="p-0 text-right">
                <b-button :disabled="caixaItem.excluir.parametros.overlay" variant="danger" pill class="px-4 font-weight-bold shadow-sm" @click="deleteItem()">
                  <i class="fa fa-trash mr-1"></i> CONFIRMAR EXCLUSÃO
                </b-button>
              </b-col>
            </b-row>
          </div>
        </b-modal>
      </div>
    </div>
    <!--  ------------------------------ FIM MODAL EXCLUIR TITULO ---------------------------- -->
    <!--  -----------------------------------------------------------------------------------
                                        MODAL TRANSFERIR 
          ----------------------------------------------------------------------------------- -->
    <div>
      <div>     
        <b-modal ref="modal-transferir" 
            id="modal-transferir" 
            hide-header
            no-close-on-esc
            no-close-on-backdrop
            body-class="p-0 overflow-hidden"
            size="lg"
            @shown="focus_modalTransferir()" 
            content-class="border-0 shadow-lg"
        >
          <b-overlay :show="caixaItem.transferir.parametros.overlay" 
                      no-wrap 
                      z-index="1100" 
                      spinner-variant="info"
                      spinner-type="border">
            <template #overlay>
              <div class="text-center text-info">
                <i class="fa fa-exchange fa-3x mb-2"></i>
                <p class="font-weight-bold">Transferindo lançamento...</p>
              </div>
            </template>
          </b-overlay>

          <div class="modal-header-premium p-3 d-flex align-items-center bg-info" style="background: linear-gradient(135deg, #17a2b8 0%, #117a8b 100%) !important;">
            <div class="header-icon-wrapper mr-3 bg-white-10">
              <i class="fa fa-exchange"></i>
            </div>
            <div>
              <h5 class="mb-0 font-weight-bold text-white">Transferir Lançamento</h5>
              <small class="text-white opacity-75">Mover registro entre contas bancárias</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-transferir')">
              <i class="fa fa-times fa-lg"></i>
            </b-button>
          </div>

          <div class="p-4 bg-white">
              <div class="modal-info-bar mb-4 bg-soft-info border">
                <b-row>
                  <b-col md="6">
                    <small class="modal-label-premium">Origem Atual</small>
                    <p class="mb-2 font-weight-bold text-dark"><i class="fa fa-university mr-2 text-muted"></i>{{nomeContaSelecionada}}</p>
                    <small class="modal-label-premium">Histórico</small>
                    <p class="mb-0 text-muted">{{caixaItem.info.nomeHistorico}}</p>
                  </b-col>
                  <b-col md="6" class="border-left">
                    <small class="modal-label-premium">Descrição</small>
                    <p class="mb-2 text-muted">{{caixaItem.info.descricao}}</p>
                    <small class="modal-label-premium">Valor</small>
                    <p class="mb-0 h5 text-info font-weight-bold">{{caixaItem.info.valor}}</p>
                  </b-col>
                </b-row>
              </div>

              <div class="modal-section-title">
                <i class="fa fa-arrow-circle-right mr-2 text-info"></i> Destino da Transferência
              </div>
              
              <b-row class="modal-field-group">
                <b-col md="12">
                  <label class="modal-label-premium" for="comboContaTransfereId">Conta Bancária de Destino</label>
                  <b-form-select  
                        v-model="caixaItem.transferir.contaTransfereId" 
                        :options="contas.optionsTransfere" 
                        :state="validou_item_transferir_conta"
                        id="comboContaTransfereId"
                        ref="comboContaTransfereId"
                        class="rounded-pill shadow-xs"
                  >
                    <template slot="first">
                      <option :value="null">-- Selecione a conta de destino --</option>
                    </template>
                  </b-form-select>
                </b-col>
              </b-row>

              <b-row class="modal-field-group">
                <b-col md="6">
                  <label class="modal-label-premium" for="edDataTransfere">Data Efetiva</label>
                   <b-form-input
                        type="date"
                        id="edDataTransfere"
                        :max="hoje"
                        v-model="caixaItem.transferir.dataTransfere"
                        :state="validou_item_transferir_data"
                        class="rounded-pill shadow-xs"
                    ></b-form-input>
                </b-col>
                <b-col md="6">
                  <label class="modal-label-premium" for="edMotivoTransferir">Observação / Justificativa</label>
                  <b-form-input 
                    type="text" 
                    id="edMotivoTransferir"
                    v-model="caixaItem.transferir.motivo" 
                    :state="validou_item_transferir_motivo"
                    placeholder="Ex: Correção de lançamento..." 
                    class="rounded-pill shadow-xs"
                    ref="edMotivoTransferir"
                  />
                </b-col>
              </b-row>
          </div>

          <div class="modal-footer-premium p-3 bg-light">
            <b-row class="w-100 m-0">
              <b-col class="p-0">
                <b-button :disabled="caixaItem.transferir.parametros.overlay" variant="soft-secondary" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modal-transferir')">
                  FECHAR
                </b-button>
              </b-col>
              <b-col class="p-0 text-right">
                <b-button :disabled="caixaItem.transferir.parametros.overlay" variant="info" pill class="px-4 font-weight-bold shadow-sm" @click="transferirItem()">
                  <i class="fa fa-refresh mr-1"></i> EXECUTAR TRANSFERÊNCIA
                </b-button>
              </b-col>
            </b-row>
          </div>
        </b-modal>
      </div>
    </div>
    <!--  ------------------------------ FIM MODAL TRANSFERIR---------------------------- -->  
    
    <!--/.row-->
    <b-card>
      <div class="row">
        <div class="col-sm-12">
          <b-btn  type="button" @click="voltarParaPesquisa()" ><i class="fa fa-arrow-left"></i> Voltar</b-btn>
        </div>
      </div>
    </b-card>
    
  </div>
</template>

<script>
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import ClientePesquisa from '../../pesquisa/ClientePesquisa.vue'
import HistoricoCaixaDropdown from '../../componentes/dropdown/HistoricoCaixaDropdown.vue'
import CentroCustoDropDown from '../../componentes/dropdown/CentroCustoDropDown.vue'
import CecInputData from '../../../components/Cec/CecInputData.vue'
import CecSelectSearch from '../../componentes/dropdown/CecSelectSearch.vue'
import moment from 'moment'
import VueAutonumeric from 'vue-autonumeric'
import Tools from '@/tools/tools.js'

export default {
  data () {
    return {
      desabilitado: true,
      registro: [],
      isLoading: false,
      status: '',
      formatoMoeda: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      contas: {
        items: [],
        id: null,
        options: [],
        optionsTransfere: []
      },
      dtMovimento: null,
      caixa: {
        registro: {
             SEQUENCIA: null        
            ,COD_BANCO: null                
            ,COD_CONTA: null               
            ,DT_MOV: null        
            ,DT_MOV2: null          
            ,SALDO_ATUAL: null             
            ,SALDO_ANT: null               
            ,T_CREDITO: null               
            ,T_DEBITO: null                
            ,STATUS: null                  
            ,DT_FECHA: null                
            ,DT_LANCAMENTO: null           
            ,T_CARTOES: null               
            ,T_REMESSA_CARTOES: null       
            ,T_SALDO_CARTOES_ATUAL: null   
            ,T_SALDO_CARTOES_ANTERIOR: null
            ,T_SALDO_FUTURO: null          
            ,NOME_BANCO: null
            ,NOME_CONTA: null
            ,T_COMPENSACAO: null
        }
      },
      caixaItem:{
        parametros: {
          overlay: false,
          submmited: false
        },
        info: {
          id: '',
          nomeBanco: '',
          nomeConta: '',
          dataMov: '',
          tipoMov: '',
          nomeHistorico: '',
          nomeCentroCusto: '',
          nomeCliente: '',
          descricao: '',
          valor: 0.00,
          motivoAlteracao: null,
          motivoExclusao: null,
          
        },
        tipoPagamento: {
          items: []
        },
        excluir: {
          parametros: {
            overlay: false,
            submmited: false
          },
          registro: {
            OBS_EXCLUIR: null
          }
        },
        transferir: {
          parametros: {
            overlay: false,
            submmited: false
          },
          contaTransfereId: null,
          dataTransfere: null,
          motivo: null
        },
        registro: {
          CONTADOR: null,
          SEQUENCIA: null, 
          COD_CONTA: null,
          DOCUMENTO: null,
          COD_BANCO: null,
          COD_PLANO: null,
          OCORRENCIA: null,
          TIPO_MOV: null,
          DT_MOV: null,
          VL_MOV: null,
          FORMA: null,
          CONTROL_CHEQUE: null,
          MARCA: null,
          OBS: null,
          COD_CENTRO1: null,
          HORA: null,
          PARCELA: null,
          CLIENTE_ID: null
        }
      },
      tabelaMovimento: {
        fields: [
          {
            key: "DOCUMENTO",
            label: 'Documento'
          },
          {
            key: "NOME_PLANO",
            label: 'Histórico'
          },
          {
            key: "NOME_CLIENTE",
            label: 'Cliente\Fornecedor'
          },
          {
            key: "OBS",
            label: 'Descrição'
          },
          {
            key: "FORMA",
            label: 'Tipo Documento'
          },
          {
            key: "TIPO_MOV",
            label: 'Lançamento'
          },
          {
            key: 'USUARIO_INCLUSAO', 
            label: 'Usuário', 
            sortable: true,
            thStyle: { width: '5% !important'}
          },
          
          {
            key: 'VL_COMPENSACAO', 
            class:'text-right', 
            label: 'Compensação (R$)', 
            sortable: true,
            thStyle: { width: '10% !important'},
            formatter: (value, key, item) => 
              (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
          },
          {
            key: 'VL_CREDITO', 
            class:'text-right', 
            label: 'Crédito (R$)', 
            sortable: true,
            thStyle: { width: '10% !important'},
            formatter: (value, key, item) => 
              (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
          },
          {
            key: 'VL_DEBITO', 
            class:'text-right', 
            label: 'Débito (R$)', 
            sortable: true,
            thStyle: { width: '10% !important'},
            formatter: (value, key, item) => 
              (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
          },
          {
            key: "actions" ,
            label: 'Ações',
            class:'text-right',
            thStyle: { width: '10% !important'} 
          }
        /*  {
            key: 'dt',
            label: 'Vencimento',
            formatter: (value, key, item) => 
              moment(value).format("DD/MM/YYYY")
          },*/
          
        ],
        items: [],
        isBusy: false
      },
         
      optionshistoricos: [],
      optionsGrupos: [],
      submmited: false
    }
  },
  components: {
    VueButtonSpinner,
    CentroCustoDropDown,
    HistoricoCaixaDropdown,
    ClientePesquisa,
    CecInputData,
    CecSelectSearch,
    VueAutonumeric
  },
  computed: {
    dataDoMovimento() {
       return Tools.formatarDataBR(this.caixa.registro.DT_MOV)
    },
    nomeContaSelecionada() {
      if (!this.contas.id) return ''
      const conta = this.contas.items.find(c => c.CODIGO == this.contas.id )      
      return conta.NOME_CONTA ?? ''

    },
    hoje() {
      return Tools.formatarDataParaInput(Tools.getDataAtual())
    },
    isValidParcelamento () {
      return    !!this.parcelamentoParametros.valor > 0
             && !!this.parcelamentoParametros.vez
             && !!this.parcelamentoParametros.dias
    },
    validouItemPost() {
      //console.log para testar todos os campos
      
      return     this.caixaItem.registro.DOCUMENTO 
              && this.caixaItem.registro.VL_MOV
              && this.caixaItem.registro.VL_MOV > 0
              && this.caixaItem.registro.COD_PLANO
              && this.caixaItem.registro.COD_CENTRO1
              && this.caixaItem.registro.FORMA
              && this.caixaItem.registro.OBS
    },
    validouItemEdit() {
      return     this.caixaItem.registro.DOCUMENTO 
              && this.caixaItem.registro.VL_MOV
              && this.caixaItem.registro.VL_MOV > 0
              && this.caixaItem.registro.COD_PLANO
              && this.caixaItem.registro.COD_CENTRO1
              && this.caixaItem.registro.FORMA
              && this.caixaItem.registro.OBS
              && this.caixaItem.info.motivoAlteracao
    },
    validouExcluir() {
      return  !!this.caixaItem.info.motivoExclusao
    },
    validouTransferir() {
      return  this.caixaItem.transferir.dataTransfere && this.caixaItem.transferir.contaTransfereId && this.caixaItem.transferir.motivo
    },
    tamanhocampoPagina () {
      if (this.registro.PAGINA) {
        return this.registro.PAGINA.length > 2 ? null : false
      }
      return false
    },
    validou_item_documento () {      
      let existe = !!this.caixaItem.registro.DOCUMENTO
      return this.caixaItem.parametros.submmited ? (existe ? null : false)  : null
    },
    validou_item_valor () {      
      let existe =  this.caixaItem.registro.VL_MOV  && this.caixaItem.registro.VL_MOV > 0
      return this.caixaItem.parametros.submmited ? (existe ? null : false)  : null
    },
    validou_item_historico () {      
      let existe =  !!this.caixaItem.registro.COD_PLANO
      return this.caixaItem.parametros.submmited ? (existe ? null : false)  : null
    },
    validou_item_cliente () {      
      let existe =  !!this.caixaItem.registro.CLIENTE_ID
      return this.caixaItem.parametros.submmited ? (existe ? null : false)  : null
    },
    validou_item_centro_custo () {      
      let existe =  !!this.caixaItem.registro.COD_CENTRO1
      return this.caixaItem.parametros.submmited ? (existe ? null : false)  : null
    },
    validou_item_forma () {      
      let existe =  !!this.caixaItem.registro.FORMA
      return this.caixaItem.parametros.submmited ? (existe ? null : false)  : null
    },
    validou_item_observacao () {      
      let existe =  !!this.caixaItem.registro.OBS
      return this.caixaItem.parametros.submmited ? (existe ? null : false)  : null
    },
    validou_item_motivo_alteracao () {      
      let existe =  !!this.caixaItem.info.motivoAlteracao
      return this.caixaItem.parametros.submmited ? (existe ? null : false)  : null
    },
    validou_item_motivo_exclusao () {      
      let existe =  !!this.caixaItem.info.motivoExclusao
      return this.caixaItem.excluir.parametros.submmited ? (existe ? null : false)  : null
    },
    validou_item_transferir_conta () {      
      let existe =  !!this.caixaItem.transferir.contaTransfereId
      return this.caixaItem.transferir.parametros.submmited ? (existe ? null : false)  : null
    },
    validou_item_transferir_data () {      
      let existe =  !!this.caixaItem.transferir.dataTransfere
      return this.caixaItem.transferir.parametros.submmited ? (existe ? null : false)  : null
    },
    validou_item_transferir_motivo () {      
      let existe =  !!this.caixaItem.transferir.motivo
      return this.caixaItem.transferir.parametros.submmited ? (existe ? null : false)  : null
    },
    validou_item_excluir_observacao () {      
      let existe =  !!this.caixaItem.excluir.registro.OBS_EXCLUIR
      return this.caixaItem.excluir.parametros.submmited ? (existe ? null : false)  : null
    },
    
    validouCampos_Item () {
      return false
    }
  },
  methods: {
    getFlagItemCaixa(item, campoLongo, campoCurto) {
      const valor = item?.[campoLongo] != null ? item[campoLongo] : item?.[campoCurto]
      return Number(valor || 0)
    },
    itemCaixaBloqueado(item) {
      return Number(item?.TEM_CONCILIACAO || 0) === 1 ||
        this.getFlagItemCaixa(item, 'TEM_CONFERENCIA_FINANCEIRA_ABERTA', 'TCFA') === 1 ||
        this.getFlagItemCaixa(item, 'TEM_CONFERENCIA_FINANCEIRA_FECHADA', 'TCFF') === 1 ||
        this.getFlagItemCaixa(item, 'MOVIMENTO_CONTA_FECHADO', 'MCF') === 1 ||
        item?.RECEBIDO_ID != null ||
        item?.PAGO_ID != null
    },
    getMensagemBloqueioItemCaixa(item) {
      if (this.getFlagItemCaixa(item, 'TEM_CONFERENCIA_FINANCEIRA_FECHADA', 'TCFF') === 1) {
        return 'Este lançamento pertence a uma Conferência Financeira fechada e não pode ser alterado ou excluído.'
      }

      if (this.getFlagItemCaixa(item, 'TEM_CONFERENCIA_FINANCEIRA_ABERTA', 'TCFA') === 1) {
        return 'Este lançamento pertence a uma Conferência Financeira em andamento e não pode ser alterado.'
      }

      if (this.getFlagItemCaixa(item, 'MOVIMENTO_CONTA_FECHADO', 'MCF') === 1) {
        return 'O movimento da conta deste período está fechado. Reabra o movimento para realizar alterações.'
      }

      if (Number(item?.TEM_CONCILIACAO || 0) === 1) {
        return 'Este lançamento está vinculado à conciliação bancária e não pode ser alterado ou excluído.'
      }

      if (item?.RECEBIDO_ID != null || item?.PAGO_ID != null) {
        return 'Este lançamento foi gerado por uma baixa financeira e deve ser desfeito pela rotina de contas pagas/recebidas.'
      }

      return ''
    },
    getMensagemErro(err, fallback = 'Operação indisponível!') {
      return err?.response?.data || err?.message || fallback
    },
    obterQueryMovimento() {
      const contaId = this.contas.id || this.caixa.registro.COD_CONTA || this.$route.query?.contaId || ''
      const dtMov = this.dtMovimento || Tools.formatarDataParaInput(this.caixa.registro.DT_MOV) || this.$route.query?.dtMov || ''

      return {
        contaId: contaId ? String(contaId) : undefined,
        dtMov: dtMov || undefined
      }
    },
    atualizarRotaLancamento(movimentoId) {
      if (!movimentoId) {
        return
      }

      this.$router.replace({
        path: `/movimentos/caixa/lancamento/${movimentoId}`,
        query: this.obterQueryMovimento()
      })
    },
    voltarParaPesquisa() {
      this.$router.push({
        path: '/movimentos/caixa/pesquisa/',
        query: this.obterQueryMovimento()
      })
    },
    async recarregarMovimentoAtual() {
      if (!this.contas.id || !this.dtMovimento) {
        return false
      }

      const movimentoId = await this.abrirMovimento()
      if (!movimentoId) {
        return false
      }

      await this.carregarCabecalho(movimentoId)
      await this.carregarItens()
      this.atualizarRotaLancamento(movimentoId)
      return true
    },
    async onChangeConta() {
      await this.recarregarMovimentoAtual()
    },
    /*************************** MODAL ITEM CAIXA  ***********************************/
   focus_modalTransferir() {
    console.log(this.$refs)
      this.$refs.modal-transferir.$refs.comboContaTransfereId.focus()
    },
    focus_modalcaixaItem() {
      this.$refs.edItemDocumento.focus()
    },
    async onClick_abrirModalAlterarItem(it) {
      if (this.itemCaixaBloqueado(it)) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', this.getMensagemBloqueioItemCaixa(it))
        return false
      }

      try {
        this.$store.commit('controle/setAguardando', true)
        this.limparRegistro()

        let tipoPagamentoResult = null
        try { 
          tipoPagamentoResult = await this.$http.get('/api/protected/tipopagamento/listartodos')
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Os tipos de pagamentos estão indisponíveis!' )
          return
        }
        
        const tipoPagamentos = tipoPagamentoResult.data
        if (!tipoPagamentos) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Os tipos de pagamentos estão indisponíveis!' )
          return
        }
        this.caixaItem.tipoPagamento.items = []
        for (let i = 0; i < tipoPagamentos.length; i++) {
          this.caixaItem.tipoPagamento.items.push({value: tipoPagamentos[i].CODIGONOME, text: tipoPagamentos[i].CODIGONOME})
        }
        
        let itemResult = null
        try {
          itemResult = await this.$http.get(`/api/protected/caixa/item/getbyid/${it.CONTADOR}`)
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Operação indisponível não foi possilve ler o item!' )
          return
        } 
        
        this.caixaItem.registro = itemResult.data?.[0]
        if (!this.caixaItem.registro) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Operação indisponível não foi possilve ler o item!' )
          return
        }

        this.$refs['modal-item-caixa'].show()
        return true
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
      
    },
    async onClick_abrirModalIncluirItem() {
      try {
        this.$store.commit('controle/setAguardando', true)
        this.limparRegistro()
        let tipoPagamentoResult = null
        try { 
          tipoPagamentoResult = await this.$http.get('/api/protected/tipopagamento/listartodos')
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Os tipos de pagamentos estão indisponíveis!' )
          return
        }
        
        const tipoPagamentos = tipoPagamentoResult.data
        if (!tipoPagamentos) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Os tipos de pagamentos estão indisponíveis!' )
          return
        }
        this.caixaItem.tipoPagamento.items = []
        for (let i = 0; i < tipoPagamentos.length; i++) {
          this.caixaItem.tipoPagamento.items.push({value: tipoPagamentos[i].CODIGONOME, text: tipoPagamentos[i].CODIGONOME})
        }
        this.$refs['modal-item-caixa'].show()
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    /*****************  FIM MODAL ITEM CAIXA ******************************************/

    /*************************** MODAL EXCLUIR  ***********************************/
    focus_modalExcluir() {
      this.$refs.edItemObsExcluir.focus()
    },
    async onClick_abrirModalExcluir(it) {
      if (this.itemCaixaBloqueado(it)) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', this.getMensagemBloqueioItemCaixa(it))
        return false
      }

      try {
        this.$store.commit('controle/setAguardando', true)
        this.limparRegistro()

        
        
        let itemResult = null
        try {
          itemResult = await this.$http.get(`/api/protected/caixa/item/getbyid/${it.CONTADOR}`)
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Operação indisponível não foi possilve ler o item!' )
          return
        } 
        
        this.caixaItem.registro = itemResult.data?.[0]
        if (!this.caixaItem.registro) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Operação indisponível não foi possilve ler o item!' )
          return
        }

        this.caixaItem.info.nomeCentroCusto = it.NOME_CENTRO
        this.caixaItem.info.nomeHistorico = it.NOME_PLANO
        this.caixaItem.info.nomeCliente = it.NOME_CLIENTE
        this.caixaItem.info.descricao = it.DESCRICAO
        this.caixaItem.info.valor = it.VL_MOV?.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})

        this.$refs['modal-excluir'].show()
        return true
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async deleteItem() {
      if (!this.validouExcluir) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Preencha todos os campos obrigatórios!' )
        return
      }
      try {
        this.caixaItem.excluir.parametros.submmited = true
        this.caixaItem.excluir.parametros.overlay = true
  
        let pacote = {
          itemId: this.caixaItem.registro.CONTADOR,
          login: window.localStorage.getItem('login'),
          motivo: this.caixaItem.info.motivoExclusao
        }
      
        try {
          await this.$http.post(`/api/protected/caixa/item/delete`, pacote)
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', this.getMensagemErro(err, 'Não foi possível excluir o lançamento!') )
          return
        }

        await this.abrirMovimento()
        await this.carregarCabecalho( this.caixa.registro.SEQUENCIA )
        await this.carregarItens()
        this.$refs['modal-excluir'].hide()
      
      } finally {
        this.isLoading = false
        this.toastCount++
        this.caixaItem.excluir.parametros.submmited = false
        this.caixaItem.excluir.parametros.overlay = false
      }
    },
    getMunicipios () {
      // this.$nextTick(() => {
      this.municipiosBusy = true
      if (this.registro.UF_ID) {
        let uri = `/api/protected/municipios/${this.registro.UF_ID}`
        let promise = this.$http.get(uri)
        return promise.then((data) => {
          this.municipios = data.data
          this.municipiosBusy = false
        })
      } else {
        this.municipios = []
        this.municipiosBusy = false
      }
      // })
    },

    /*****************  FIM MODAL EXCLUIR ******************************************/

    rowClassListagem(item, type) {
      if (item && type === 'row') {
        if ((item.TIPO_MOV) && (item.TIPO_MOV.trim() === 'CREDITO')) {
          return 'text-verde'
        } else if ((item.TIPO_MOV) && (item.TIPO_MOV.trim() === 'DEBITO')) {
          return 'text-vermelho'
        } else if ((item.TIPO_MOV) && (item.TIPO_MOV.trim() === 'COMPENSACAO')) {
          return 'text-azul'
        } 
      } else {
        return null
      }
    },
    async abrirModalTransferir (it) {
      try {
        this.$store.commit('controle/setAguardando', true)
        this.limparRegistro()

        
        
        let itemResult = null
        try {
          itemResult = await this.$http.get(`/api/protected/caixa/item/getbyid/${it.CONTADOR}`)
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Operação indisponível não foi possilve ler o item!' )
          return
        } 
        
        this.caixaItem.registro = itemResult.data?.[0]
        if (!this.caixaItem.registro) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Operação indisponível não foi possilve ler o item!' )
          return
        }

        this.contas.optionsTransfere = []
        for (let i = 0; i < this.contas.items.length; i++) {
          if (this.contas.items[i].CODIGO != this.contas.id) {
            this.contas.optionsTransfere.push({value: this.contas.items[i].CODIGO, text: this.contas.items[i].NOME_CONTA})
          }
        }

        this.caixaItem.info.nomeCentroCusto = it.NOME_CENTRO
        this.caixaItem.info.nomeHistorico = it.NOME_PLANO
        this.caixaItem.info.nomeCliente = it.NOME_CLIENTE
        this.caixaItem.info.descricao = it.DESCRICAO
        this.caixaItem.transferir.dataTransfere = Tools.formatarDataParaInput(this.dtMovimento)
        this.caixaItem.transferir.motivo = null
        this.caixaItem.transferir.contaTransfereId = null 
        this.$refs['modal-transferir'].show()
        return true
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async transferirItem() {
      if (!this.validouTransferir) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Preencha todos os campos obrigatórios!' )
        return
      }
      try {
        this.caixaItem.transferir.parametros.submmited = true
        this.caixaItem.transferir.parametros.overlay = true
  
        let pacote = {
          itemId: this.caixaItem.registro.CONTADOR,
          contaId: this.caixaItem.transferir.contaTransfereId,
          dtMov: this.caixaItem.transferir.dataTransfere,
          login: window.localStorage.getItem('login'),
          motivo: this.caixaItem.transferir.motivo
        }
      
        try {
          await this.$http.post(`/api/protected/caixa/item/transferir`, pacote)
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return
        }

        await this.abrirMovimento()
        await this.carregarCabecalho( this.caixa.registro.SEQUENCIA )
        await this.carregarItens()
        this.$refs['modal-transferir'].hide()
      
      } finally {
        this.isLoading = false
        this.toastCount++
        this.caixaItem.transferir.parametros.submmited = false
        this.caixaItem.transferir.parametros.overlay = false
      }
    },
    onHidden_botaoParcelamento() {
      // Return focus to the button
      this.$refs.bt_gerarParcelamento.focus()
    },
    onHidden_botaoGerarDocumento() {
      // Return focus to the button
      this.$refs.bt_gerarDocumento.focus()
    },
    onClick_botaoGerarDocumento() {

      let uri = `/api/protected/areceber/getnovonumerodocumento`
      this.$http.get(uri)
      .then((data) => {
        this.caixaItem.registro.DOCUMENTO = data.data
      })
    },
    async postItem () {
      //Testar se o item realmente é novo
      if (this.registro.CONTADOR) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Esse item não é um novo cadastro!' )
        return
      }

      if (!this.validouItemPost) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Preenche todos os campos obrigatórios!' )
        return
      }
      try {
        this.caixaItem.parametros.submmited = true
        this.caixaItem.parametros.overlay = true
  
        let pacote = {
          registro: this.caixaItem.registro,
          login: window.localStorage.getItem('login')
        }
      
        try {
          await this.$http.post(`/api/protected/caixa/item/post`, pacote)
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return
        }

        await this.abrirMovimento()
        await this.carregarCabecalho( this.caixa.registro.SEQUENCIA )
        await this.carregarItens()
        this.$refs['modal-item-caixa'].hide()
      
      } finally {
        this.isLoading = false
        this.toastCount++
        this.caixaItem.parametros.submmited = false
        this.caixaItem.parametros.overlay = false
      }
    },
    async editItem() {
      if (!this.validouItemEdit) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Preenche todos os campos obrigatórios!' )
        return
      }
      try {
        this.caixaItem.parametros.submmited = true
        this.caixaItem.parametros.overlay = true
  
        let pacote = {
          registro: this.caixaItem.registro,
          login: window.localStorage.getItem('login'),
          motivo: this.caixaItem.info.motivoAlteracao
        }
      
        try {
          await this.$http.post(`/api/protected/caixa/item/edit`, pacote)
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return
        }

        await this.abrirMovimento()
        await this.carregarCabecalho( this.caixa.registro.SEQUENCIA )
        await this.carregarItens()
        this.$refs['modal-item-caixa'].hide()
      
      } finally {
        this.isLoading = false
        this.toastCount++
        this.caixaItem.parametros.submmited = false
        this.caixaItem.parametros.overlay = false
      }
    },
    getMunicipios () {
      // this.$nextTick(() => {
      this.municipiosBusy = true
      if (this.registro.UF_ID) {
        let uri = `/api/protected/municipios/${this.registro.UF_ID}`
        let promise = this.$http.get(uri)
        return promise.then((data) => {
          this.municipios = data.data
          this.municipiosBusy = false
        })
      } else {
        this.municipios = []
        this.municipiosBusy = false
      }
      // })
    },
    limparRegistro () {
      let registroVazio =
      {
        CONTADOR: null,
        SEQUENCIA: this.caixa.registro.SEQUENCIA,
        DOCUMENTO: null,
        COD_BANCO: this.caixa.registro.COD_BANCO,
        COD_CONTA: this.caixa.registro.COD_CONTA,
        COD_PLANO: null,
        OCORRENCIA: null,
        TIPO_MOV: null,
        DT_MOV: this.caixa.registro.DT_MOV,
        VL_MOV: 0.00,
        FORMA: null,
        CONTROL_CHEQUE: null,
        MARCA: null,
        OBS: null,
        COD_CENTRO1: null,
        HORA: null,
        PARCELA: null,
        CLIENTE_ID: null
      }
      this.caixaItem.info.nomeBanco = this.caixa.registro.NOME_BANCO
      this.caixaItem.info.nomeConta = this.caixa.registro.NOME_CONTA
      this.caixaItem.info.dataMov = this.caixa.registro.DT_MOV
      this.caixaItem.info.motivoAlteracao = null
      this.caixaItem.info.motivoExclusao = null
      this.caixaItem.excluir.registro.OBS_EXCLUIR = ''
      

      this.caixaItem.registro = registroVazio
    },
    iniciarFormNovo () {
      //this.limparRegistro()
      // this.desabilitado = false
    },
    async carregarContas() {
      try {
        const body = {
          login: window.localStorage.getItem('login'),
          origem: 'web'
        }
        const dadosResult = await this.$http.post(`/api/protected/conta/listarPorLogin/`, body)

        this.contas.items = dadosResult?.data?? null
      } catch (err) {
        throw err
      }

      if (!this.contas.items) {
        console.log('erro em  =>  /api/protected/caixa/getbyid')
        throw err
      }
      
      //this.contas.options.push({value: null, text: '-- Escolha uma Conta --'})
      for (let i = 0; i < this.contas.items.length; i++) {
        this.contas.options.push({value: this.contas.items[i].CODIGO, text: this.contas.items[i].NOME_CONTA})
      }
    },
    async iniciarFormPrincipal() {
      try {
          this.tabelaMovimento.isBusy = true
          this.tabelaMovimento.items = []  
      } finally {

        this.tabelaMovimento.isBusy = false
      }

    },

    async carregarCabecalho(id) {
        try {
          const dadosResult = await this.$http.get(`/api/protected/caixa/getbyid/${id}`)

          this.caixa.registro = dadosResult?.data?.[0]
        } catch (err) {
           throw err
        }

        if (!this.caixa.registro) {
          console.log('erro em  =>  /api/protected/caixa/getbyid')
          throw err
        }
        this.caixa.registro.T_CREDITO = this.caixa.registro.T_CREDITO?.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
        this.caixa.registro.T_DEBITO = this.caixa.registro.T_DEBITO?.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
        this.caixa.registro.DT_MOV  = Tools.formatarDataParaInput(this.caixa.registro.DT_MOV)
        this.caixa.registro.DT_MOV2  = Tools.formatarDataParaInput(this.caixa.registro.DT_MOV)
        this.caixa.registro.SALDO_ANT = this.caixa.registro.SALDO_ANT?.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
        this.caixa.registro.SALDO_ATUAL = this.caixa.registro.SALDO_ATUAL?.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
        this.caixa.registro.T_COMPENSACAO = this.caixa.registro.T_COMPENSACAO?.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
        

        
    },
    async carregarItens() {
      let movimentoResult = null
      try {
        movimentoResult = await this.$http.get(`/api/protected/caixa/listarmovimento/${this.caixa.registro.SEQUENCIA}`)
      } catch (err) {
        throw err
      }

      const movimentos = movimentoResult?.data ?? null
      if (!movimentos) {
        console.log('erro em  =>  /api/protected/caixa/listarmovimento')
        throw err
      }
      
      this.tabelaMovimento.items = movimentos
    },
    imprimirLivroCaixa() {
      let dt1 = new Date(this.caixa.registro.DT_MOV).toJSON().slice(0, 10)
      let dt2 = new Date(this.caixa.registro.DT_MOV).toJSON().slice(0, 10)
      
      
      let uri = '/api/protected/relatorios/relcaixalivro?contaid=' + this.caixa.registro.COD_CONTA +
              '&dt1=' + dt1 +
              '&dt2=' + dt2 +
              '&lbempresa=' + window.localStorage.getItem('nomeempresa') +
              '&lbusuario=' + window.localStorage.getItem('login') +
              '&lbbanco=' + this.caixa.registro.NOME_BANCO +
              '&lbconta=' + this.caixa.registro.NOME_CONTA
      this.$store.commit('controle/setAguardando', true)  
      this.$http.get(uri, {responseType: 'arraybuffer'})
        .then(response => {
          this.$store.commit('controle/setAguardando', false)
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'relLivroCaixa.pdf') 
          link.download = 'relLivroCaixa.pdf'
          // document.body.appendChild(link)
          //link.click()
          // document.body.removeChild(link)
          const janela = window.open(link)
          /*
          setTimeout(() =>
            { 
                janela.document.title = 'Relatório de Vendas'; 
            }, 1000);
            */
          
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = this.caixa.registro.COD_CONTA +' Relatório do Livro do Caixa'
            }, 2000);
          }

          this.$root.$bvToast.toast(`Relatório Gerado com sucesso!!!`, {
            title: 'Aviso',
            autoHideDelay: 2000,
            variant: 'success',
            appendToast: true
          })
          
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          this.$toast.error({
            title: 'Erro',
            message: 'Ocorreram erros ao gerar o Relatorio ',
            progressBar: false,
            showMethod: 'shake',
            position: 'top full width'
          })
        })
    },
    imprimirMovimentoCaixa() {
      let dt1 = new Date(this.caixa.registro.DT_MOV).toJSON().slice(0, 10)
      let dt2 = new Date(this.caixa.registro.DT_MOV).toJSON().slice(0, 10)
     

      let uri = '/api/protected/relatorios/relcaixamovimento?contaId=' + this.caixa.registro.COD_CONTA +
          '&lbEmpresa=' + window.localStorage.getItem('nomeempresa') +
          '&dt1=' + dt1 +
          '&dt2=' + dt2 +
          '&lbUsuario=' + window.localStorage.getItem('login')


      this.$store.commit('controle/setAguardando', true)  
      this.$http.get(uri, {responseType: 'arraybuffer'})
        .then(response => {
          this.$store.commit('controle/setAguardando', false)
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'relMovimentoConta.pdf') 
          link.download = 'relMovimentoConta.pdf'
          // document.body.appendChild(link)
          //link.click()
          // document.body.removeChild(link)
          const janela = window.open(link)
          /*
          setTimeout(() =>
            { 
                janela.document.title = 'Relatório de Vendas'; 
            }, 1000);
            */
          
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = this.caixa.registro.COD_CONTA +' Relatório do Movimento da Conta'
            }, 2000);
          }

          this.$root.$bvToast.toast(`Relatório Gerado com sucesso!!!`, {
            title: 'Aviso',
            autoHideDelay: 2000,
            variant: 'success',
            appendToast: true
          })
          
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          this.$toast.error({
            title: 'Erro',
            message: 'Ocorreram erros ao gerar o Relatorio ',
            progressBar: false,
            showMethod: 'shake',
            position: 'top full width'
          })
        })

    },
    async abrirMovimento () {
      try {
        this.$store.commit('controle/setAguardando', true)
        
        let body = {
          contaId: this.contas.id,
          login: window.localStorage.getItem('login'),
          dtMov: this.dtMovimento,
          origem: 'web'
        }
        let movimentoResult = null
        try {
          movimentoResult = await this.$http.post('/api/protected/caixa/abrirmovimento', body)
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', this.getMensagemErro(err, 'Não foi possível abrir o movimento da conta!') )
          return false
        }

        const movimentoId = movimentoResult.data?.id?? null

        if (!movimentoId) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel abrir o movimento da conta!' )
          return false
        }

        this.caixa.registro.SEQUENCIA = movimentoId
        return movimentoId
       
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }  


    },
    decrementarData() {
      const data = Tools.getAcrescentarData(this.dtMovimento, -1)
      this.dtMovimento = data
    },
    acrescentarData() {
      const novaData = Tools.getAcrescentarData(this.dtMovimento, 1)
      const hoje = Tools.getDataAtual()

      if (novaData <= hoje) {
        this.dtMovimento = novaData
      }
    }
    
  },
  async created () {
    let id = this.$route.params.id
    
    try {
      await this.carregarCabecalho( id )
    } catch (err) {
      console.log(err)
      Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Nao foi possivel abrir o movimento da Conta' )
      return
    }
    try {
      await this.carregarContas()
    } catch (err) {
      console.log(err)
      Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Nao foi possivel listar as contas do usuário' )
      return
    }

    try {
      await this.carregarItens()
    } catch (err) {
      console.log(err)
      Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Nao foi exibir os lançamentos do Movimento' )
      return
    }
    this.dtMovimento = Tools.formatarDataParaInput(this.caixa.registro.DT_MOV)
    this.contas.id = this.caixa.registro.COD_CONTA
    this.atualizarRotaLancamento(this.caixa.registro.SEQUENCIA)

    
  },
  async mounted() {
    this.$nextTick(() => {
    })
  },
  watch: {
    'dtMovimento': async function(val, old) {
      if (!old || !val || val === old) return
      await this.recarregarMovimentoAtual()

    },
    'caixaItem.registro.COD_PLANO': function () {
      if (this.caixaItem.registro.COD_PLANO <= 0) {
        this.caixaItem.registro.TIPO_MOV = ''
        return
      }
      let uri = this.$http.defaults.baseURL.concat(`api/protected/historico/getbyid/${this.caixaItem.registro.COD_PLANO}`)
      this.$http.get(uri)
      .then((data) => {
          if (data) {
            this.caixaItem.registro.TIPO_MOV = data.data[0].TIPO
            return true
          }
      })
      .catch(erro => {
        this.toastCount++
        this.$root.$bvToast.toast(`Falha ao pesquisar o tipo do Historico!! ${erro}`, {
          title: 'Erro',
          autoHideDelay: 5000,
          variant: 'danger',
          appendToast: true
        })
      })
    }
  }
}
</script>
<style scoped>
/* DashBoard Colors & Vars */
:root {
  --primary-gradient: linear-gradient(135deg, #20a8d8 0%, #1783ae 100%);
  --success-bg: rgba(77, 189, 116, 0.1);
  --danger-bg: rgba(248, 108, 107, 0.1);
  --info-bg: rgba(99, 194, 222, 0.1);
  --primary-bg: rgba(32, 168, 216, 0.1);
}

.dashboard-card {
  border-radius: 12px !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;
}

.dashboard-header {
  background: var(--primary-gradient, linear-gradient(135deg, #343a40 0%, #212529 100%)) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.header-icon-wrapper {
  width: 45px;
  height: 45px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
}

.bg-white-10 {
  background: rgba(255, 255, 255, 0.1);
}

.border-white-20 {
  border-color: rgba(255, 255, 255, 0.2) !important;
}

.letter-spacing-1 {
  letter-spacing: 1px;
}

.custom-select-transparent {
  padding-left: 10px;
  cursor: pointer;
  outline: none;
}

.stat-item {
  border: 1px solid #e0e0e0;
  transition: all 0.3s ease;
}

.bg-soft-success { background-color: #e6f9ed; border-color: #c3f2d7 !important; }
.bg-soft-danger { background-color: #fff0f0; border-color: #ffdada !important; }
.bg-soft-info { background-color: #e0f7fa; border-color: #b2ebf2 !important; }
.bg-soft-primary { background-color: #e3f2fd; border-color: #bbdefb !important; }

.transition-hover:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.05) !important;
}

.scale-110 {
  transform: scale(1.05);
  z-index: 2;
}

.opacity-75 { opacity: 0.75; }

.text-verde { color: #28a745 !important; font-weight: bold; }
.text-vermelho { color: #dc3545 !important; font-weight: bold; }
.text-azul { color: #007bff !important; font-weight: bold; }

.action-pill {
  width: 32px;
  height: 32px;
  border-radius: 50% !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 !important;
  transition: all 0.2s;
}

.action-pill:hover {
  transform: scale(1.15);
}

.badge-finance {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.5em 0.8em;
  border-radius: 6px;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.75rem;
}

.table.b-table > tbody > tr > td {
  vertical-align: middle;
}

.shadow-xs { box-shadow: 0 2px 4px rgba(0,0,0,0.02); }

/* Soft Button Variants */
.btn-soft-primary { background-color: #e3f2fd; color: #007bff; border: none; }
.btn-soft-primary:hover { background-color: #007bff; color: white; }

.btn-soft-success { background-color: #e6f9ed; color: #28a745; border: none; }
.btn-soft-success:hover { background-color: #28a745; color: white; }

.btn-soft-warning { background-color: #fff9db; color: #f0ad4e; border: none; }
.btn-soft-warning:hover { background-color: #f0ad4e; color: white; }

.btn-soft-danger { background-color: #fff0f0; color: #dc3545; border: none; }
.btn-soft-danger:hover { background-color: #dc3545; color: white; }

.btn-soft-info { background-color: #e0f7fa; color: #17a2b8; border: none; }
.btn-soft-info:hover { background-color: #17a2b8; color: white; }

/* Premium Modal Styles */
.modal-content {
  border: none !important;
  border-radius: 12px !important;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1) !important;
}

.modal-header-premium {
  background: var(--primary-gradient, linear-gradient(135deg, #343a40 0%, #212529 100%)) !important;
  color: white !important;
  border-bottom: none !important;
  padding: 1rem 1.5rem !important;
  position: relative;
}

.modal-footer-premium {
  border-top: 1px solid #f0f0f0 !important;
  padding: 1rem 1.5rem !important;
  background-color: #f8f9fa !important;
  border-bottom-left-radius: 12px !important;
  border-bottom-right-radius: 12px !important;
}

.modal-info-bar {
  background: #f8f9fa;
  border-radius: 10px;
  padding: 1.25rem;
}

.modal-label-premium {
  font-weight: 700;
  color: #6c757d;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin-bottom: 0.35rem;
}

.modal-field-group {
  margin-bottom: 1.2rem;
}

.modal-section-title {
  font-weight: 800;
  color: #2c3e50;
  border-bottom: 2px solid #edf2f7;
  padding-bottom: 0.4rem;
  margin-bottom: 1.25rem;
  font-size: 0.95rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.badge-finance.variant-soft-danger { background-color: #fff0f0; color: #dc3545; }
.badge-finance.variant-soft-success { background-color: #e6f9ed; color: #28a745; }
</style>





// WEBPACK FOOTER //
// src/views/movimentos/caixa/CaixaLancamento.vue